import { Link, Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import React from "react";
import { AreaListLayout } from "./components/AreaListLayout";
import { AreaDetailLayout } from "./components/AreaDetailLayout";
import { AreaEmployeeList } from "./components/AreaEmployeeList";
import { AreaHistoryList } from "./components/AreaHistoryList";
import { AreaActiveList } from "./components/AreaActiveList";
import { AreaInactiveList } from "./components/AreaInactiveList";

export const LinkArea = ({ area, children }) => {
  if (!area) return null;

  return <Link to={`/areas/${area.id}`}>{children || area.name}</Link>;
};

export const AreaRoutes = () => {
  let { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/:area_id(\\d+)`}>
        <AreaDetailLayout />
      </Route>
      <Route path={path}>
        <AreaListLayout />
      </Route>
    </Switch>
  );
};

export const AreaDetailRoutes = ({ area_id }) => {
  let { url, path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/historico`}>
        <AreaHistoryList area_id={area_id} />
      </Route>
      <Route path={`${path}/funcionarios`}>
        <AreaEmployeeList area_id={area_id} />
      </Route>
      <Redirect to={`${url}/funcionarios`} />
    </Switch>
  );
};

export function AreaListRoutes({ search, areaData }) {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/inativos`}>
        <AreaInactiveList search={search} />
      </Route>
      <Route path={path}>
        <AreaActiveList areaData={areaData} />
      </Route>
    </Switch>
  );
}
